import Car2GridContainer from "../../../components/car/grid/Car2Grid";

const Car2Grid = () => {
  return <Car2GridContainer />;
};

export default Car2Grid;
